import {Component, Input, OnInit} from "@angular/core";
import {ILockObject} from "../../../services/lock.service";
import {LanguageChangeService} from "../../../services/language-change.service";
import {Config} from "src/app/services/utils/Config";

@Component({
  selector: "app-lock-card",
  templateUrl: "./lock-card.component.html",
  styleUrls: ["./lock-card.component.css"]
})
export class LockCardComponent implements OnInit {
  @Input() lock: ILockObject;
  @Input() viewType: string;
  @Input() member: boolean;
  homeName: string;
  batteryLevel = 20;
  isLoaderActive = false;

  constructor(
    private langService: LanguageChangeService,
  ) {}

  ngOnInit() {
  }

  convertDateFormat(date) {
    const d = new Date(date * 1000);
    const day = String(d.getUTCDate()).padStart(2, '0');
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][d.getUTCMonth()];
    const year = d.getUTCFullYear();
    return `${month} ${day}, ${year}`;
  }

  convertFirstLetter(lockState) {
    const capitalizedState = lockState.charAt(0).toUpperCase() + lockState.slice(1);
    const historyChecklist = Config.HISTORY_CHECKLISTS.find(
      ele => ele[this.langService.getDefaultLanguage()] === capitalizedState
    );
    return historyChecklist ? historyChecklist[this.langService.getCurrentLanguage()] : '';
  }

  checkUpdateLastStatus(lastUpdateStatus) {
    let currentDate = Math.floor(Date.now() / 1000);
    let lockStatus = currentDate - lastUpdateStatus;
    return lockStatus > Config.UPDATE_STATUS_SECONDS ? false : true;
  }

}
